// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__32BUf","info":"Note_info__1suUD","note":"Note_note__28ywv","actions":"Note_actions__Mj-1-"};